// React import removed
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { SpecialTarifsContent } from '@/pageContents/specialTarifs/SpecialTarifsContent';
import { Permission } from '@/models/user';

const SpecialTarifs: PageWithLayout<unknown> = () => {
    return (
        <>
            <Helmet>
                <title>Spezialtarife | Starjack Backoffice</title>
            </Helmet>

            <SpecialTarifsContent isSpecialTarifsNew={false} />
        </>
    );
};

SpecialTarifs.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
SpecialTarifs.isProtected = true;
SpecialTarifs.permissions = [Permission.EXTERNAL_CODES_NAV];

export default SpecialTarifs;
